export default {
    REALIZADO: 1,
    FALTOU: 2,
    RESULTADO: 3,
    AGENDADO: 4,
    FALTA_MEDICA: 5,
    REAGENDADO: 6,
    CANCELADO: 7,
}
